import request from "@/utils/request";

// 商品查询
export function getGoodsList(params) {
  params.scene = 1;
  // 调用方可传 v=3（首页目录）/ v=5（VIN 主目录）；未传默认 v=1
  if (params.v == null || params.v === "") {
    params.v = 1;
  }
  return request({
    url: "/mall/goods/search",
    method: "post",
    data: params
  });
}

// 商品详情
export function getGoodsDetail(params) {
  return request({
    url: "/mall/goods/detail",
    method: "get",
    params: params
  });
}

// 商品详情(从订单调过来的)
export function getOrderDetailsById(params) {
  return request({
    url: `/mall/order-details/${params.id}`,
    method: "get"
  });
}
/**
 * VIN 查询
 * GET /mall/goods/search-vin：返回车型列表 vehicles + 主目录/筛选项 listSettings。
 * listSettings.catalogs 有值时，列表页点选第一个主目录查询，不再走默认关键字。
 */
export function getDataByVin(code) {
  return request({
    url: "/mall/goods/search-vin",
    method: "get",
    params: { vin: code }
  });
}
/**
 * 车架号（VIN）识别
 */
export function getOCRVin(data) {
  return request({
    url: "/ocr/vin",
    method: "POST",
    data: data
  });
}
// 获取搜索历史：goodsKeyword / vin / vinKeyword（VIN 查询下关键字）
export function getSearchHistory(type) {
  return request({
    url: `/mall/goods/history/list?type=${type}`,
    method: "get"
  });
}

//历史查询内容
export function getGoodsHistoryContent(params) {
  return request({
    url: "/mall/goods/history/content",
    method: "get",
    params: params
  });
}
/**
 * 删除指定查询历史
 */
export function deleteGoodsHistory(id) {
  return request({
    url: `/mall/goods/history/${id}`,
    method: "DELETE"
  });
}

/**
 * 删除所有查询历史
 * @param {String} type 历史类型：goodsKeyword-关键字 / vin-VIN码 / vinKeyword-VIN查询下关键字
 */
export function deleteAllGoodsHistory(type) {
  return request({
    url: "/mall/goods/history",
    method: "DELETE",
    params: { type: type }
  });
}
export function vehicleModelApi(params) {
  return request({
    url: "/mall/epc/vehicle-model/detail",
    method: "get",
    params
  });
}
